import React, { useEffect, useState } from "react";
import "../../assets/css/Herosection.css";
import { GET_CONTACT } from "../../service/admin.service";
import { downloadAPK } from "../../Helpers/DownloadAPK";
import { FaAndroid, FaDownload } from "react-icons/fa";
import girlHeroImg from "../../../images/girl-heroSection.png";

const IndiaFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 16"
    width="18"
    height="12"
    style={{
      borderRadius: "2px",
      display: "inline-block",
      flexShrink: 0,
      boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
    }}
  >
    <rect width="24" height="5.33" fill="#FF9933" />
    <rect y="5.33" width="24" height="5.33" fill="#FFFFFF" />
    <rect y="10.66" width="24" height="5.33" fill="#138808" />
    <circle cx="12" cy="8" r="2.1" fill="none" stroke="#000080" strokeWidth="0.5" />
    <circle cx="12" cy="8" r="0.4" fill="#000080" />
    {[0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165].map((deg) => (
      <line
        key={deg}
        x1="12"
        y1="5.9"
        x2="12"
        y2="10.1"
        stroke="#000080"
        strokeWidth="0.25"
        transform={`rotate(${deg} 12 8)`}
      />
    ))}
  </svg>
);

// 1. 5 Star Rating Icon
const StarFeatureIcon = () => (
  <svg viewBox="0 0 48 48" width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="starGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3ab8c6" />
        <stop offset="50%" stopColor="#237F8A" />
        <stop offset="100%" stopColor="#15555d" />
      </linearGradient>
    </defs>
    <path
      d="M24 4l6.18 12.52L44 18.52l-10 9.75 2.36 13.73L24 35.52l-12.36 6.48L14 28.27 4 18.52l13.82-2z"
      fill="url(#starGrad)"
    />
    <path
      d="M24 7.5l4.5 9.1 10 .9-7.2 7.1 1.7 10-9-4.7V7.5z"
      fill="#ffffff"
      fillOpacity="0.28"
    />
  </svg>
);

// 2. Super Fast Withdrawal Icon
const FastWithdrawalIcon = () => (
  <svg viewBox="0 0 48 48" width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="fastGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3ab8c6" />
        <stop offset="50%" stopColor="#237F8A" />
        <stop offset="100%" stopColor="#15555d" />
      </linearGradient>
    </defs>
    <rect x="3" y="17" width="6" height="2.5" rx="1.25" fill="#237F8A" />
    <rect x="1" y="23.5" width="8" height="2.5" rx="1.25" fill="#237F8A" />
    <rect x="4" y="30" width="5" height="2.5" rx="1.25" fill="#237F8A" />
    <rect x="12" y="10" width="29" height="28" rx="7" fill="url(#fastGrad)" />
    <rect x="14" y="12" width="25" height="12" rx="4" fill="#ffffff" fillOpacity="0.22" />
    <path
      d="M26.5 17v11m0 0l-4.5-4.5m4.5 4.5l4.5-4.5M20 32h13"
      stroke="#ffffff"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 3. 24/7 VIP Support Icon
const SupportIcon = () => (
  <svg viewBox="0 0 48 48" width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="supportGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3ab8c6" />
        <stop offset="50%" stopColor="#237F8A" />
        <stop offset="100%" stopColor="#15555d" />
      </linearGradient>
    </defs>
    <path
      d="M10 24c0-7.73 6.27-14 14-14s14 6.27 14 14"
      stroke="url(#supportGrad)"
      strokeWidth="3.5"
      strokeLinecap="round"
    />
    <rect x="8" y="21" width="6" height="13" rx="3" fill="url(#supportGrad)" />
    <rect x="34" y="21" width="6" height="13" rx="3" fill="url(#supportGrad)" />
    <path
      d="M37 32c0 4.42-3.58 7-8 7h-3"
      stroke="url(#supportGrad)"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="23" cy="39" r="2.8" fill="url(#supportGrad)" />
  </svg>
);

// 4. 100% Secure & Trusted Shield Icon
const ShieldIcon = () => (
  <svg viewBox="0 0 48 48" width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="shieldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3ab8c6" />
        <stop offset="50%" stopColor="#237F8A" />
        <stop offset="100%" stopColor="#15555d" />
      </linearGradient>
    </defs>
    <path
      d="M24 6l14 5.25v10.5c0 10.3-6 16.85-14 20.25-8-3.4-14-9.95-14-20.25V11.25L24 6z"
      fill="url(#shieldGrad)"
    />
    <path
      d="M24 8.5l11.5 4.3v8.7c0 8.5-5 13.9-11.5 16.7V8.5z"
      fill="#ffffff"
      fillOpacity="0.22"
    />
    <path
      d="M18 23.5l4 4 8.5-8.5"
      stroke="#ffffff"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Section2 = () => {
  const [getData, setgetData] = useState([]);

  const getResponseData = async () => {
    try {
      const res = await GET_CONTACT();
      if (res && res.data && res.data[0]) {
        setgetData(res.data[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getResponseData();
  }, []);

  const download = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const newTab = window.open("about:blank", "_blank");

    if (!newTab) {
      alert("Popup blocked! Please allow popups.");
      return;
    }

    // Favicon loader
    const loaderIcon =
      "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

    try {
      newTab.document.open();
      newTab.document.write("<html><head></head><body></body></html>");
      newTab.document.close();

      const link = newTab.document.createElement("link");
      link.rel = "icon";
      link.href = loaderIcon;
      newTab.document.head.appendChild(link);

      newTab.document.title = "Loading...";

      const url = await downloadAPK();

      if (!url) {
        newTab.close();
        return;
      }

      const a = document.createElement("a");
      a.href = url;
      a.download = "boss555.apk";
      document.body.appendChild(a);
      a.click();
      a.remove();

      setTimeout(() => {
        newTab.close();
      }, 1500);
    } catch (err) {
      newTab.close();
      console.error(err);
    }
  };

  return (
    <>
      <div className="container">
        <div className="banner-container">
          <div className="row main-contain-row align-items-center">
            <div className="col-12 col-lg-7 col-xl-6 hero-sec-left">
              <div className="banner-left">
                <div className="hero-main-wrapper">
                  {/* India No.1 Trusted App Badge with Indian Flag */}
                  <div className="hero-trusted-badge-wrapper">
                    <div className="hero-trusted-badge">
                      <IndiaFlag />
                      <span className="hero-trusted-text">
                        India’s <span className="hero-trusted-no1">No.1</span> Trusted App
                      </span>
                    </div>
                  </div>

                  {/* WELCOME TO line */}
                  <div className="hero-welcome-line">
                    <span className="hero-welcome-divider left-divider"></span>
                    <span className="hero-welcome-text">WELCOME TO</span>
                    <span className="hero-welcome-divider right-divider"></span>
                  </div>

                  {/* Khatri555 Brand Name */}
                  <h2 className="hero-brand-name">KHATRI555</h2>

                  {/* 2-line Heading */}
                  <div className="hero-heading-section">
                    <h1 className="hero-heading-line1">Play Big, Win Big</h1>
                    <h2 className="hero-heading-line2">Business Of Faith With Confidence</h2>
                  </div>

                  {/* Mobile Hero Girl Image (Placed right above Download APK button on mobile) */}
                  <div className="hero-girl-mobile-container d-lg-none">
                    <div className="hero-girl-mobile-glow"></div>
                    <img
                      src={girlHeroImg}
                      alt="Khatri555 Hero"
                      className="hero-girl-mobile-img"
                    />
                  </div>

                  {/* Download APK Button with Android and Download icons */}
                  <div className="hero-download-btn-container">
                    <button
                      type="button"
                      className="hero-download-btn"
                      onClick={download}
                      aria-label="Download APK"
                    >
                      <div className="hero-download-btn-content">
                        <FaAndroid className="hero-download-android-icon" />
                        <span className="hero-download-text">Download APK</span>
                        <FaDownload className="hero-download-arrow-icon" />
                      </div>
                    </button>
                  </div>

                  {/* 4 Trust & Feature Badges (5 Star, Super Fast, 24/7 VIP, 100% Secure) */}
                  <div className="hero-features-grid">
                    <div className="hero-feature-item">
                      <div className="hero-feature-icon-circle">
                        <StarFeatureIcon />
                      </div>
                      <span className="hero-feature-title">5 STAR</span>
                      <span className="hero-feature-subtitle">RATING</span>
                      <div className="hero-feature-accent">
                        <span className="accent-bar"></span>
                        <span className="accent-dot"></span>
                        <span className="accent-dot"></span>
                        <span className="accent-dot"></span>
                      </div>
                    </div>

                    <div className="hero-feature-item">
                      <div className="hero-feature-icon-circle">
                        <FastWithdrawalIcon />
                      </div>
                      <span className="hero-feature-title">SUPER FAST</span>
                      <span className="hero-feature-subtitle">WITHDRAWAL</span>
                      <div className="hero-feature-accent">
                        <span className="accent-bar"></span>
                        <span className="accent-dot"></span>
                        <span className="accent-dot"></span>
                        <span className="accent-dot"></span>
                      </div>
                    </div>

                    <div className="hero-feature-item">
                      <div className="hero-feature-icon-circle">
                        <SupportIcon />
                      </div>
                      <span className="hero-feature-title">24/7 VIP</span>
                      <span className="hero-feature-subtitle">SUPPORT</span>
                      <div className="hero-feature-accent">
                        <span className="accent-bar"></span>
                        <span className="accent-dot"></span>
                        <span className="accent-dot"></span>
                        <span className="accent-dot"></span>
                      </div>
                    </div>

                    <div className="hero-feature-item">
                      <div className="hero-feature-icon-circle">
                        <ShieldIcon />
                      </div>
                      <span className="hero-feature-title">100%</span>
                      <span className="hero-feature-subtitle">SECURE & TRUSTED</span>
                      <div className="hero-feature-accent">
                        <span className="accent-bar"></span>
                        <span className="accent-dot"></span>
                        <span className="accent-dot"></span>
                        <span className="accent-dot"></span>
                      </div>
                    </div>
                  </div>

                  {/* Call Now & WhatsApp Buttons (Icon on Left, Name on Right, Straight Icons) */}
                  <div className="hero-contact-btns">
                    <button type="button" className="hero-contact-btn hero-call-btn">
                      <a
                        href={`tel:+91${getData && getData.number}`}
                        className="text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 text-reset"
                      >
                        <i className="fa fa-phone me-2 hero-call-icon" aria-hidden="true"></i>
                        <span>Call Now</span>
                      </a>
                    </button>
                    <button type="button" className="hero-contact-btn hero-wa-btn">
                      <a
                        href={`https://wa.me/${getData && getData.number}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 text-reset"
                      >
                        <i className="fa fa-whatsapp me-2 hero-wa-icon" aria-hidden="true"></i>
                        <span>WhatsApp</span>
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Desktop Hero Girl Image (Right Column in empty space) */}
            <div className="col-12 col-lg-5 col-xl-6 hero-sec-right d-none d-lg-flex align-items-center justify-content-center">
              <div className="hero-girl-desktop-wrapper">
                <div className="hero-girl-glow-backdrop"></div>
                <img
                  src={girlHeroImg}
                  alt="Khatri555 Hero"
                  className="hero-girl-desktop-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section2;
